const validation = {
  hu: {
    fields: {
      unsaved_file: {
        required: "Kérjük, mentsd el a módosításokat a képszerkesztésben.",
      },
      unsaved_profile: {
        required: "Kérjük, mentsd el a módosításokat a képszerkesztésben.",
      },
      original_file: {
        required: "Először töltsd fel a fényképet",
      },
    },
    messages: {
      required: "{field} a mező kötelező.",
      email: "Pole musí byť email.",
      digits: "{field} povoľuje iba čísla.",
    },
    names: {
      name: "keresztnév",
      surname: "vezetéknév",
      address: "cím",
      number: "szám",
      city: "város",
      zip: "irányítószám",
      email: "email",
      phone: "telefonszám",
      "attributes[package_text]": "text na balíku",
      date: "dátum",
      original_file: "fájl",
      primaryText: "szöveg hozzáadása",
      song: "dal címe",
      standText: "állványon szereplő szöveg",
      accountName: "názov účtu",
      description: "leírás",
      like: "kedvelte",
      others: "és további",
      original_profile: "profilová fotografia",
      message: "správa",
      count: "počet kusov",
    },
  },
  sk: {
    fields: {
      unsaved_file: {
        required: "Uložte prosím zmeny v editácii fotky.",
      },
      unsaved_profile: {
        required: "Uložte prosím zmeny v editácii profilovky.",
      },
    },
    messages: {
      phone: "Pole {field} nie je platné.",
      digits: "Pole {field} nie je platné.",
      required: "Pole {field} je povinné.",
      email: "Pole musí byť email.",
    },
    names: {
      name: "meno",
      surname: "priezvisko",
      address: "adresa",
      number: "číslo",
      city: "mesto",
      zip: "PSČ",
      email: "email",
      phone: "tel. číslo",
      "attributes[package_text]": "text na balíku",
      date: "dátum",
      original_file: "súbor",
      primaryText: "hlavný text",
      song: "názov piesne",
      standText: "text na stojane",
      accountName: "názov účtu",
      description: "popis",
      like: "páči sa to",
      others: "a ďalším",
      original_profile: "profilová fotografia",
      message: "správa",
      count: "počet kusov",
    },
  },
  cs: {
    fields: {
      unsaved_file: {
        required: "Uložte prosím změny v editaci fotky.",
      },
      unsaved_profile: {
        required: "Uložte prosím změny v editaci profilovky.",
      },
    },
    messages: {
      phone: "Pole {field} není platné.",
      digits: "Pole {field} není platné.",
      required: "Pole {field} je povinné.",
      email: "Pole musí být email.",
    },
    names: {
      name: "jméno",
      surname: "příjmení",
      address: "adresa",
      number: "číslo",
      city: "město",
      zip: "PSČ",
      email: "email",
      phone: "tel. číslo",
      "attributes[package_text]": "text na balíku",
      date: "datum",
      original_file: "soubor",
      primaryText: "hlavní text",
      song: "název písne",
      standText: "text na stojanu",
      accountName: "název účtu",
      description: "popis",
      like: "líbí se to",
      others: "a dalším",
      original_profile: "profilová fotografie",
      message: "zpráva",
      count: "počet kusů",
    },
  },
};

export default validation;
